import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const ScreeningQuestionsBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  };
}) as typeof Box;

export const ScreeningQuestionsBlockLabel = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21px',
    marginBottom: '7px',
  };
}) as typeof Box;

export const ScreeningQuestionsBlockQuestion = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EDF1FF',
    padding: '16px',
    gap: '16px',
    marginBottom: '4px',
  };
}) as typeof Box;

export const ScreeningQuestionsBlockQuestionText = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header_unknown,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
  };
}) as typeof Box;

export const ScreeningQuestionsBlockAddBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    minHeight: '50px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',

    '> p': {
      color: palette.text.header_accent,
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '21px',
    },
  };
}) as typeof Box;
